import { enqueueSnackbar, UploadMultipleFiles, DownloadFile, UploadFiles } from 'actions';

import {
	GetFailuresFiltersRequest,
	GetFailuresPointsVoiceRequest,
	GetFailuresPointsPacketRequest,
	GetDriveTestsCitiesRequest,
	GetDriveTestsDrivesRequest,
	GetDriveTestsDatesRequest,
	GetDriveTestsLogsRequest,
	GetDriveTestRequest,
	GetUeRouteRequest,
	// Scanner
	GetDriveTestScannerFrequenciesRequest,
	GetDriveTestScannerCodesRequest,
	GetDriveTestScannerRequest,
	GetScannerRouteRequest,
	GetCrowdsourcingRequest,
	GetTopologyRequest,
	GetSitesIdsRequest,
	GetSiteIdLocationRequest,
	GetCarriersColorsRequest,
	SaveCarrierColorRequest,
	UploadCustomLayerRequest,
	GetCustomLayerRequest,
	ExportScannerRequest,
	RunXcapToolRequest
} from '../requests/DualMapRequests';

// Map
export const SET_FORM_STATE = 'SET_FORM_STATE';
export const RESET_FIELDS = 'RESET_FIELDS';
export const GET_FAILURES_FILTERS = 'GET_FAILURES_FILTERS';
export const GET_FAILURES_VOICE = 'GET_FAILURES_VOICE';
export const GET_FAILURES_PACKET = 'GET_FAILURES_PACKET';
export const SET_SELECTED_DATES = 'SET_SELECTED_DATES';
export const SET_SELECTED_LOGS = 'SET_SELECTED_LOGS';
export const GET_DRIVETESTS_CITIES = 'GET_DRIVETESTS_CITIES';
export const GET_DRIVETESTS_DRIVES = 'GET_DRIVETESTS_DRIVES';
export const GET_DRIVETESTS_DATES = 'GET_DRIVETESTS_DATES';
export const GET_DRIVETESTS_LOGS = 'GET_DRIVETESTS_LOGS';
export const GET_DRIVETEST = 'GET_DRIVETEST';
export const GET_DRIVETESTS_TECH_BAND = 'GET_DRIVETESTS_TECH_BAND';
export const GET_UE_ROUTE = 'GET_UE_ROUTE';
// Scanner
export const GET_DRIVETEST_SCANNER_FREQUENCIES_2G = 'GET_DRIVETEST_SCANNER_FREQUENCIES_2G';
export const GET_DRIVETEST_SCANNER_FREQUENCIES_3G = 'GET_DRIVETEST_SCANNER_FREQUENCIES_3G';
export const GET_DRIVETEST_SCANNER_FREQUENCIES_4G = 'GET_DRIVETEST_SCANNER_FREQUENCIES_4G';
export const GET_DRIVETEST_SCANNER_FREQUENCIES_5G = 'GET_DRIVETEST_SCANNER_FREQUENCIES_5G';
export const GET_DRIVETEST_SCANNER_CODES_2G = 'GET_DRIVETEST_SCANNER_CODES_2G';
export const GET_DRIVETEST_SCANNER_CODES_3G = 'GET_DRIVETEST_SCANNER_CODES_3G';
export const GET_DRIVETEST_SCANNER_CODES_4G = 'GET_DRIVETEST_SCANNER_CODES_4G';
export const GET_DRIVETEST_SCANNER_CODES_5G = 'GET_DRIVETEST_SCANNER_CODES_5G';
export const GET_DRIVETEST_SCANNER = 'GET_DRIVETEST_SCANNER';
export const GET_SCANNER_ROUTE = 'GET_SCANNER_ROUTE';
export const GET_CROWDSOURCING = 'GET_CROWDSOURCING';
export const GET_TOPOLOGY_2G = 'GET_TOPOLOGY_2G';
export const GET_TOPOLOGY_3G = 'GET_TOPOLOGY_3G';
export const GET_TOPOLOGY_4G = 'GET_TOPOLOGY_4G';
export const GET_TOPOLOGY_5G = 'GET_TOPOLOGY_5G';
export const GET_SITES_IDS = 'GET_SITES_IDS';
export const GET_SITE_ID_LOCATION = 'GET_SITE_ID_LOCATION';
export const GET_CUSTOM_LAYER = 'GET_CUSTOM_LAYER';

// Map Compare
export const GET_FAILURES_FILTERS_COMPARE = 'GET_FAILURES_FILTERS_COMPARE';
export const GET_FAILURES_VOICE_COMPARE = 'GET_FAILURES_VOICE_COMPARE';
export const GET_FAILURES_PACKET_COMPARE = 'GET_FAILURES_PACKET_COMPARE';
export const SET_SELECTED_DATES_COMPARE = 'SET_SELECTED_DATES_COMPARE';
export const GET_DRIVETESTS_CITIES_COMPARE = 'GET_DRIVETESTS_CITIES_COMPARE';
export const GET_DRIVETESTS_DRIVES_COMPARE = 'GET_DRIVETESTS_DRIVES_COMPARE';
export const GET_DRIVETESTS_DATES_COMPARE = 'GET_DRIVETESTS_DATES_COMPARE';
export const GET_DRIVETEST_COMPARE = 'GET_DRIVETEST_COMPARE';
export const GET_DRIVETEST_SCANNER_FREQUENCIES_2G_COMPARE = 'GET_DRIVETEST_SCANNER_FREQUENCIES_2G_COMPARE';
export const GET_DRIVETEST_SCANNER_FREQUENCIES_3G_COMPARE = 'GET_DRIVETEST_SCANNER_FREQUENCIES_3G_COMPARE';
export const GET_DRIVETEST_SCANNER_FREQUENCIES_4G_COMPARE = 'GET_DRIVETEST_SCANNER_FREQUENCIES_4G_COMPARE';
export const GET_DRIVETEST_SCANNER_FREQUENCIES_5G_COMPARE = 'GET_DRIVETEST_SCANNER_FREQUENCIES_5G_COMPARE';
export const GET_DRIVETEST_SCANNER_CODES_2G_COMPARE = 'GET_DRIVETEST_SCANNER_CODES_2G_COMPARE';
export const GET_DRIVETEST_SCANNER_CODES_3G_COMPARE = 'GET_DRIVETEST_SCANNER_CODES_3G_COMPARE';
export const GET_DRIVETEST_SCANNER_CODES_4G_COMPARE = 'GET_DRIVETEST_SCANNER_CODES_4G_COMPARE';
export const GET_DRIVETEST_SCANNER_CODES_5G_COMPARE = 'GET_DRIVETEST_SCANNER_CODES_5G_COMPARE';
export const GET_DRIVETEST_SCANNER_COMPARE = 'GET_DRIVETEST_SCANNER_COMPARE';
export const GET_SCANNER_ROUTE_COMPARE = 'GET_SCANNER_ROUTE_COMPARE';
export const GET_CROWDSOURCING_COMPARE = 'GET_CROWDSOURCING_COMPARE';
export const GET_TOPOLOGY_2G_COMPARE = 'GET_TOPOLOGY_2G_COMPARE';
export const GET_TOPOLOGY_3G_COMPARE = 'GET_TOPOLOGY_3G_COMPARE';
export const GET_TOPOLOGY_4G_COMPARE = 'GET_TOPOLOGY_4G_COMPARE';
export const GET_TOPOLOGY_5G_COMPARE = 'GET_TOPOLOGY_5G_COMPARE';

// Global
export const TOGGLE_FILTERS = 'TOGGLE_FILTERS';
export const CLEAR_FORM = 'CLEAR_FORM';
export const TOGGLE_SUMMARY_DIALOG = 'TOGGLE_SUMMARY_DIALOG';
export const TOGGLE_CARRIERS_COLORS_DIALOG = 'TOGGLE_CARRIERS_COLORS_DIALOG';
export const TOGGLE_CUSTOM_LAYER_DIALOG = 'TOGGLE_CUSTOM_LAYER_DIALOG';
export const GET_CARRIERS_COLORS = 'GET_CARRIERS_COLORS';
export const TOGGLE_CARRIERS_COLORS_PICKER_DIALOG = 'TOGGLE_CARRIERS_COLORS_PICKER_DIALOG';
export const TOGGLE_ATTACH_FILES_DIALOG = 'TOGGLE_ATTACH_FILES_DIALOG';
export const TOGGLE_XCAP_TOOL_DIALOG = 'TOGGLE_XCAP_TOOL_DIALOG';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

const onResetFields = () => ({
	type: RESET_FIELDS,
});

// Map
// Failures
const onGetFailuresFilters = (value) => ({
	type: GET_FAILURES_FILTERS,
	failuresFilters: value
});

const onGetFailuresPointsVoice = (value) => ({
	type: GET_FAILURES_VOICE,
	failuresVoice: value
});

const onGetFailuresPointsPacket = (value) => ({
	type: GET_FAILURES_PACKET,
	failuresPacket: value
});

// DriveTests
const onSetSelectedDates = (value) => ({
	type: SET_SELECTED_DATES,
	selectedDates: value
});

const onSetSelectedLogs = (value) => ({
	type: SET_SELECTED_LOGS,
	selectedLogs: value
});

const onGetDriveTestsCities = (value) => ({
	type: GET_DRIVETESTS_CITIES,
	cities: value
});

const onGetDriveTestsDrives = (value) => ({
	type: GET_DRIVETESTS_DRIVES,
	drives: value
});

const onGetDriveTestsDates = (value) => ({
	type: GET_DRIVETESTS_DATES,
	dates: value
});

const onGetDriveTestsLogs = (value) => ({
	type: GET_DRIVETESTS_LOGS,
	logs: value
});

const onGetDriveTest = (value) => ({
	type: GET_DRIVETEST,
	driveTest: value
});

const onGetUeRoute = (value) => ({
	type: GET_UE_ROUTE,
	ueRoute: value
});

// Scanner
const onGetDriveTestScannerFrequencies2g = (value) => ({
	type: GET_DRIVETEST_SCANNER_FREQUENCIES_2G,
	driveTestScannerFrequencies2g: value
});

const onGetDriveTestScannerFrequencies3g = (value) => ({
	type: GET_DRIVETEST_SCANNER_FREQUENCIES_3G,
	driveTestScannerFrequencies3g: value
});

const onGetDriveTestScannerFrequencies4g = (value) => ({
	type: GET_DRIVETEST_SCANNER_FREQUENCIES_4G,
	driveTestScannerFrequencies4g: value
});

const onGetDriveTestScannerFrequencies5g = (value) => ({
	type: GET_DRIVETEST_SCANNER_FREQUENCIES_5G,
	driveTestScannerFrequencies5g: value
});

const onGetDriveTestScannerCodes2g = (value) => ({
	type: GET_DRIVETEST_SCANNER_CODES_2G,
	driveTestScannerCodes2g: value
});

const onGetDriveTestScannerCodes3g = (value) => ({
	type: GET_DRIVETEST_SCANNER_CODES_3G,
	driveTestScannerCodes3g: value
});

const onGetDriveTestScannerCodes4g = (value) => ({
	type: GET_DRIVETEST_SCANNER_CODES_4G,
	driveTestScannerCodes4g: value
});

const onGetDriveTestScannerCodes5g = (value) => ({
	type: GET_DRIVETEST_SCANNER_CODES_5G,
	driveTestScannerCodes5g: value
});

const onGetDriveTestScanner = (value) => ({
	type: GET_DRIVETEST_SCANNER,
	driveTestScanner: value
});

const onGetScannerRoute = (value) => ({
	type: GET_SCANNER_ROUTE,
	scannerRoute: value
});

// Crowdsourcing
const onGetCrowdsourcing = (value) => ({
	type: GET_CROWDSOURCING,
	crowdsourcing: value
});

// Topology
const onGetTopology2g = (value) => ({
	type: GET_TOPOLOGY_2G,
	topology2gData: value
});

const onGetTopology3g = (value) => ({
	type: GET_TOPOLOGY_3G,
	topology3gData: value
});

const onGetTopology4g = (value) => ({
	type: GET_TOPOLOGY_4G,
	topology4gData: value
});

const onGetTopology5g = (value) => ({
	type: GET_TOPOLOGY_5G,
	topology5gData: value
});

const onGetCustomLayer = (value) => ({
	type: GET_CUSTOM_LAYER,
	customLayer: value
});

// Map Compare
// Failures
const onGetFailuresFiltersCompare = (value) => ({
	type: GET_FAILURES_FILTERS_COMPARE,
	failuresFiltersCompare: value
});
const onGetFailuresPointsVoiceCompare = (value) => ({
	type: GET_FAILURES_VOICE_COMPARE,
	failuresVoiceCompare: value
});

const onGetFailuresPointsPacketCompare = (value) => ({
	type: GET_FAILURES_PACKET_COMPARE,
	failuresPacketCompare: value
});

// DriveTests
const onSetSelectedDatesCompare = (value) => ({
	type: SET_SELECTED_DATES_COMPARE,
	selectedDatesCompare: value
});

const onGetDriveTestsCitiesCompare = (value) => ({
	type: GET_DRIVETESTS_CITIES_COMPARE,
	citiesCompare: value
});

const onGetDriveTestsDrivesCompare = (value) => ({
	type: GET_DRIVETESTS_DRIVES_COMPARE,
	drivesCompare: value
});

const onGetDriveTestsDatesCompare = (value) => ({
	type: GET_DRIVETESTS_DATES_COMPARE,
	datesCompare: value
});

const onGetDriveTestCompare = (value) => ({
	type: GET_DRIVETEST_COMPARE,
	driveTestCompare: value
});

// Scanner
const onGetDriveTestScannerFrequencies2gCompare = (value) => ({
	type: GET_DRIVETEST_SCANNER_FREQUENCIES_2G_COMPARE,
	driveTestScannerFrequencies2gCompare: value
});

const onGetDriveTestScannerFrequencies3gCompare = (value) => ({
	type: GET_DRIVETEST_SCANNER_FREQUENCIES_3G_COMPARE,
	driveTestScannerFrequencies3gCompare: value
});

const onGetDriveTestScannerFrequencies4gCompare = (value) => ({
	type: GET_DRIVETEST_SCANNER_FREQUENCIES_4G_COMPARE,
	driveTestScannerFrequencies4gCompare: value
});

const onGetDriveTestScannerFrequencies5gCompare = (value) => ({
	type: GET_DRIVETEST_SCANNER_FREQUENCIES_5G_COMPARE,
	driveTestScannerFrequencies5gCompare: value
});

const onGetDriveTestScannerCodes2gCompare = (value) => ({
	type: GET_DRIVETEST_SCANNER_CODES_2G_COMPARE,
	driveTestScannerCodes2gCompare: value
});

const onGetDriveTestScannerCodes3gCompare = (value) => ({
	type: GET_DRIVETEST_SCANNER_CODES_3G_COMPARE,
	driveTestScannerCodes3gCompare: value
});

const onGetDriveTestScannerCodes4gCompare = (value) => ({
	type: GET_DRIVETEST_SCANNER_CODES_4G_COMPARE,
	driveTestScannerCodes4gCompare: value
});

const onGetDriveTestScannerCodes5gCompare = (value) => ({
	type: GET_DRIVETEST_SCANNER_CODES_5G_COMPARE,
	driveTestScannerCodes5gCompare: value
});

const onGetDriveTestScannerCompare = (value) => ({
	type: GET_DRIVETEST_SCANNER_COMPARE,
	driveTestScannerCompare: value
});

const onGetScannerRouteCompare = (value) => ({
	type: GET_SCANNER_ROUTE_COMPARE,
	scannerRouteCompare: value
});

// Crowdsourcing
const onGetCrowdsourcingCompare = (value) => ({
	type: GET_CROWDSOURCING_COMPARE,
	crowdsourcingCompare: value
});

// Topology
const onGetTopology2gCompare = (value) => ({
	type: GET_TOPOLOGY_2G_COMPARE,
	topology2gDataCompare: value
});

const onGetTopology3gCompare = (value) => ({
	type: GET_TOPOLOGY_3G_COMPARE,
	topology3gDataCompare: value
});

const onGetTopology4gCompare = (value) => ({
	type: GET_TOPOLOGY_4G_COMPARE,
	topology4gDataCompare: value
});

const onGetTopology5gCompare = (value) => ({
	type: GET_TOPOLOGY_5G_COMPARE,
	topology5gDataCompare: value
});

// Global
const onToggleFilters = (openFilters) => ({
	type: TOGGLE_FILTERS,
	openFilters,
});

const onClearForm = () => ({
	type: CLEAR_FORM
});

const onToggleSummaryDialog = (visible) => ({
	type: TOGGLE_SUMMARY_DIALOG,
	visible
});

const onToggleCarriersColorsDialog = (visible) => ({
	type: TOGGLE_CARRIERS_COLORS_DIALOG,
	visible
});

const onToggleCustomLayerDialog = (visible) => ({
	type: TOGGLE_CUSTOM_LAYER_DIALOG,
	visible
});

const onToggleCarriersColorsPickerDialog = (visible, tableIdColorCode, currentColorCode) => ({
	type: TOGGLE_CARRIERS_COLORS_PICKER_DIALOG,
	visible,
	tableIdColorCode,
	currentColorCode
});

const onGetSitesIds = (value) => ({
	type: GET_SITES_IDS,
	sitesIds: value
});

const onGetSiteIdLocation = (value) => ({
	type: GET_SITE_ID_LOCATION,
	siteIdLocation: value
});

const onGetCarriersColors = (value) => ({
	type: GET_CARRIERS_COLORS,
	carriersColors: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const ResetFields = () => (dispatch) => {
	dispatch(onResetFields());
};

// Failures
export const GetFailuresFilters = (role) => async (dispatch) => {
	await GetFailuresFiltersRequest(role).then(response => {
		dispatch(onGetFailuresFilters(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetFailuresPointsVoice = (userId, role, city, dates, logs, failureType, cfn1Level) => async (dispatch) => {
	await GetFailuresPointsVoiceRequest(userId, role, 'voice', city, dates, logs, failureType, cfn1Level).then(response => {
		dispatch(onGetFailuresPointsVoice(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetFailuresPointsPacket = (userId, role, city, dates, logs, failureType, cfn1Level) => async (dispatch) => {
	await GetFailuresPointsPacketRequest(userId, role, 'packet', city, dates, logs, failureType, cfn1Level).then(response => {
		dispatch(onGetFailuresPointsPacket(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

// DriveTests
export const GetDriveTestsCities = (userId, userOperator) => async (dispatch) => {
	await GetDriveTestsCitiesRequest(userId, userOperator).then(response => {
		dispatch(onGetDriveTestsCities(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestsDrives = (city) => async (dispatch) => {
	await GetDriveTestsDrivesRequest(city).then(response => {
		dispatch(onGetDriveTestsDrives(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestsDates = (city, drive) => async (dispatch) => {
	await GetDriveTestsDatesRequest(city, drive).then(response => {
		dispatch(onGetDriveTestsDates(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestsLogs = (city, dates) => async (dispatch) => {
	await GetDriveTestsLogsRequest(city, dates).then(response => {
		dispatch(onGetDriveTestsLogs(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SetSelectedDates = (selectedDates) => (dispatch) => {
	dispatch(onSetSelectedDates(selectedDates));
};

export const SetSelectedLogs = (selectedLogs) => (dispatch) => {
	dispatch(onSetSelectedLogs(selectedLogs));
};

export const GetDriveTest = (userId, tech, city, dates, logs, kpi) => async (dispatch) => {
	await GetDriveTestRequest(userId, tech, city, dates, logs, kpi).then(response => {
		dispatch(onGetDriveTest(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetUeRoute = (userId, city, dates, logs) => async (dispatch) => {
	await GetUeRouteRequest(userId, city, dates, logs).then(response => {
		dispatch(onGetUeRoute(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

// Scanner
export const GetDriveTestScannerFrequencies2g = (userId, tech, city, dates, freq, top) => async (dispatch) => {
	await GetDriveTestScannerFrequenciesRequest(userId, tech, city, dates, freq, top).then(response => {
		dispatch(onGetDriveTestScannerFrequencies2g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestScannerFrequencies3g = (userId, tech, city, dates, freq, top) => async (dispatch) => {
	await GetDriveTestScannerFrequenciesRequest(userId, tech, city, dates, freq, top).then(response => {
		dispatch(onGetDriveTestScannerFrequencies3g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestScannerFrequencies4g = (userId, tech, city, dates, freq, top) => async (dispatch) => {
	await GetDriveTestScannerFrequenciesRequest(userId, tech, city, dates, freq, top).then(response => {
		dispatch(onGetDriveTestScannerFrequencies4g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestScannerFrequencies5g = (userId, tech, city, dates, freq, top) => async (dispatch) => {
	await GetDriveTestScannerFrequenciesRequest(userId, tech, city, dates, freq, top).then(response => {
		dispatch(onGetDriveTestScannerFrequencies5g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestScannerCodes2g = (userId, tech, city, dates, freq, top) => async (dispatch) => {
	await GetDriveTestScannerCodesRequest(userId, tech, city, dates, freq, top).then(response => {
		dispatch(onGetDriveTestScannerCodes2g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestScannerCodes3g = (userId, tech, city, dates, freq, top) => async (dispatch) => {
	await GetDriveTestScannerCodesRequest(userId, tech, city, dates, freq, top).then(response => {
		dispatch(onGetDriveTestScannerCodes3g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestScannerCodes4g = (userId, tech, city, dates, freq, top) => async (dispatch) => {
	await GetDriveTestScannerCodesRequest(userId, tech, city, dates, freq, top).then(response => {
		dispatch(onGetDriveTestScannerCodes4g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestScannerCodes5g = (userId, tech, city, dates, freq, top) => async (dispatch) => {
	await GetDriveTestScannerCodesRequest(userId, tech, city, dates, freq, top).then(response => {
		dispatch(onGetDriveTestScannerCodes5g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestScanner = (userId, tech, city, dates, kpi, freq, top, code) => async (dispatch) => {
	await GetDriveTestScannerRequest(userId, tech, city, dates, kpi, freq, top, code).then(response => {
		dispatch(onGetDriveTestScanner(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetScannerRoute = (userId, city, dates) => async (dispatch) => {
	await GetScannerRouteRequest(userId, city, dates).then(response => {
		dispatch(onGetScannerRoute(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

// Crowdsourcing
export const GetCrowdsourcing = (userId, tech, city, dates, kpi) => async (dispatch) => {
	await GetCrowdsourcingRequest(userId, tech, city, dates, kpi).then(response => {
		dispatch(onGetCrowdsourcing(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

// Topology
export const GetTopology2g = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyRequest(userId, '2G', bands, coordinates).then(response => {
		dispatch(onGetTopology2g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopology3g = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyRequest(userId, '3G', bands, coordinates).then(response => {
		dispatch(onGetTopology3g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopology4g = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyRequest(userId, '4G', bands, coordinates).then(response => {
		dispatch(onGetTopology4g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopology5g = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyRequest(userId, '5G', bands, coordinates).then(response => {
		dispatch(onGetTopology5g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetCustomLayer = (userId) => async (dispatch) => {
	await GetCustomLayerRequest(userId).then(response => {
		dispatch(onGetCustomLayer(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ToggleFilters = (openFilters) => (dispatch) => {
	dispatch(onToggleFilters(openFilters));
};

export const ClearForm = () => (dispatch) => {
	dispatch(onClearForm());
};

export const ToggleSummaryDialog = (visible) => (dispatch) => {
	dispatch(onToggleSummaryDialog(visible));
};

export const ToggleCarriersColorsDialog = (visible) => (dispatch) => {
	dispatch(onToggleCarriersColorsDialog(visible));
};

export const ToggleCustomLayerDialog = (visible) => (dispatch) => {
	dispatch(onToggleCustomLayerDialog(visible));
};

export const ToggleCarriersColorsPickerDialog = (visible, tableIdColorCode, currentColorCode) => (dispatch) => {
	dispatch(onToggleCarriersColorsPickerDialog(visible, tableIdColorCode, currentColorCode));
};

// Map Compare
// Failures
export const GetFailuresFiltersCompare = (role) => async (dispatch) => {
	await GetFailuresFiltersRequest(role).then(response => {
		dispatch(onGetFailuresFiltersCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetFailuresPointsVoiceCompare = (userId, role, city, dates, failureType, cfn1Level) => async (dispatch) => {
	await GetFailuresPointsVoiceRequest(userId, role, 'voice', city, dates, failureType, cfn1Level).then(response => {
		dispatch(onGetFailuresPointsVoiceCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetFailuresPointsPacketCompare = (userId, role, city, dates, failureType, cfn1Level) => async (dispatch) => {
	await GetFailuresPointsPacketRequest(userId, role, 'packet', city, dates, failureType, cfn1Level).then(response => {
		dispatch(onGetFailuresPointsPacketCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

// DriveTests
export const GetDriveTestsCitiesCompare = (userId, userOperator) => async (dispatch) => {
	await GetDriveTestsCitiesRequest(userId, userOperator).then(response => {
		dispatch(onGetDriveTestsCitiesCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestsDrivesCompare = (city) => async (dispatch) => {
	await GetDriveTestsDrivesRequest(city).then(response => {
		dispatch(onGetDriveTestsDrivesCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestsDatesCompare = (city, drive) => async (dispatch) => {
	await GetDriveTestsDatesRequest(city, drive).then(response => {
		dispatch(onGetDriveTestsDatesCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SetSelectedDatesCompare = (selectedDates) => (dispatch) => {
	dispatch(onSetSelectedDatesCompare(selectedDates));
};

export const GetDriveTestCompare = (userId, tech, city, dates, kpi) => async (dispatch) => {
	await GetDriveTestRequest(userId, tech, city, dates, kpi).then(response => {
		dispatch(onGetDriveTestCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

// Scanner
export const GetDriveTestScannerFrequencies2gCompare = (userId, tech, city, dates, freq, top) => async (dispatch) => {
	await GetDriveTestScannerFrequenciesRequest(userId, tech, city, dates, freq, top).then(response => {
		dispatch(onGetDriveTestScannerFrequencies2gCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestScannerFrequencies3gCompare = (userId, tech, city, dates, freq, top) => async (dispatch) => {
	await GetDriveTestScannerFrequenciesRequest(userId, tech, city, dates, freq, top).then(response => {
		dispatch(onGetDriveTestScannerFrequencies3gCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestScannerFrequencies4gCompare = (userId, tech, city, dates, freq, top) => async (dispatch) => {
	await GetDriveTestScannerFrequenciesRequest(userId, tech, city, dates, freq, top).then(response => {
		dispatch(onGetDriveTestScannerFrequencies4gCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestScannerFrequencies5gCompare = (userId, tech, city, dates, freq, top) => async (dispatch) => {
	await GetDriveTestScannerFrequenciesRequest(userId, tech, city, dates, freq, top).then(response => {
		dispatch(onGetDriveTestScannerFrequencies5gCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestScannerCodes2gCompare = (userId, tech, city, dates, freq, top) => async (dispatch) => {
	await GetDriveTestScannerCodesRequest(userId, tech, city, dates, freq, top).then(response => {
		dispatch(onGetDriveTestScannerCodes2gCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestScannerCodes3gCompare = (userId, tech, city, dates, freq, top) => async (dispatch) => {
	await GetDriveTestScannerCodesRequest(userId, tech, city, dates, freq, top).then(response => {
		dispatch(onGetDriveTestScannerCodes3gCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestScannerCodes4gCompare = (userId, tech, city, dates, freq, top) => async (dispatch) => {
	await GetDriveTestScannerCodesRequest(userId, tech, city, dates, freq, top).then(response => {
		dispatch(onGetDriveTestScannerCodes4gCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestScannerCodes5gCompare = (userId, tech, city, dates, freq, top) => async (dispatch) => {
	await GetDriveTestScannerCodesRequest(userId, tech, city, dates, freq, top).then(response => {
		dispatch(onGetDriveTestScannerCodes5gCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestScannerCompare = (userId, tech, city, dates, kpi, freq, top, code) => async (dispatch) => {
	await GetDriveTestScannerRequest(userId, tech, city, dates, kpi, freq, top, code).then(response => {
		dispatch(onGetDriveTestScannerCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetScannerRouteCompare = (userId, city, dates) => async (dispatch) => {
	await GetScannerRouteRequest(userId, city, dates).then(response => {
		dispatch(onGetScannerRouteCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

// Crowdsourcing
export const GetCrowdsourcingCompare = (userId, tech, city, dates, kpi) => async (dispatch) => {
	await GetCrowdsourcingRequest(userId, tech, city, dates, kpi).then(response => {
		dispatch(onGetCrowdsourcingCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

// Topology
export const GetTopology2gCompare = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyRequest(userId, '2G', bands, coordinates).then(response => {
		dispatch(onGetTopology2gCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopology3gCompare = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyRequest(userId, '3G', bands, coordinates).then(response => {
		dispatch(onGetTopology3gCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopology4gCompare = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyRequest(userId, '4G', bands, coordinates).then(response => {
		dispatch(onGetTopology4gCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopology5gCompare = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyRequest(userId, '5G', bands, coordinates).then(response => {
		dispatch(onGetTopology5gCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

// Global
export const GetSitesIds = () => async (dispatch) => {
	await GetSitesIdsRequest().then(response => {
		dispatch(onGetSitesIds(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetSiteIdLocation = (siteId) => async (dispatch) => {
	await GetSiteIdLocationRequest(siteId).then(response => {
		dispatch(onGetSiteIdLocation(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetCarriersColors = () => async (dispatch) => {
	await GetCarriersColorsRequest().then(response => {
		dispatch(onGetCarriersColors(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SaveCarrierColor = (userId, tableId, colorCode) => async (dispatch) => {
	await SaveCarrierColorRequest(userId, tableId, colorCode).then(response => {
		dispatch(GetCarriersColors());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const UploadCustomLayer = (folder, userId) => async (dispatch) => {
	await UploadCustomLayerRequest(folder, userId).then(response => {
		dispatch(onToggleCustomLayerDialog(false));
		dispatch(enqueueSnackbar({ message: 'Successfully uploaded layer files.', options: { variant: 'success' } }));
		dispatch(onGetCustomLayer(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const UploadCustomLayerFiles = (files, userId) => async (dispatch) => {
	await UploadMultipleFiles(files).then(response => {
		dispatch(UploadCustomLayer(response.data, userId));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

// Export Scanner
export const ExportScanner = (drive, dates) => async (dispatch) => {
	await ExportScannerRequest(drive, dates).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

// Extra Global
const onToggleXcapToolDialog = (visible) => ({
	type: TOGGLE_XCAP_TOOL_DIALOG,
	visible
});

export const ToggleXcapToolDialog = (visible) => dispatch => {
	dispatch(onToggleXcapToolDialog(visible));
};

export const RunXcapTool = (userId, folderPath) => async dispatch => {
	await RunXcapToolRequest(userId, folderPath).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch(error => {
		if (error) {
			dispatch(
				enqueueSnackbar({
					message: error.message,
					options: { variant: error.variant }
				})
			);
		}
	});
};

export const XcapToolAttachmentsUpload = (userId, files) => async dispatch => {
	await UploadFiles(files).then(response => {
		dispatch(RunXcapTool(userId, response.data));
	}).catch(error => {
		if (error) {
			dispatch(
				enqueueSnackbar({
					message: error.message,
					options: { variant: error.variant }
				})
			);
		}
	});
};
